export const tooltipContent = `
          <div class="p-4 text-white text-xs rounded-lg" style="background: #23252c;">
            <h6 class="mb-1 text-sm font-semibold">Daily Price Indicator</h6>
            <p class="mb-2">
              A <span class="font-bold">Benchmark Daily Price Indicator</span> 
              is a five UK-working day rolling average assessment of the lithium price, published by 6pm on UK working days except Wednesdays.
            </p>
            <p class="mb-2">
              Benchmark averages the mean of prices collected on each day against the mean of prices collected on each of the previous five working days, employing the data hierarchy to ensure a deference to confirmed transactional data.
            </p>
            <p>
              The Daily Price Indicator is published separately to Benchmark's IOSCO-certified Lithium Price Assessment grades.
            </p>
          </div>
          `
